import { gql } from "@apollo/client";

export const GetArticles = gql`
  query GetArticles($categorySlug: String!, $limit: Float!) {
    getArticles(categorySlug: $categorySlug, limit: $limit) {
      articles {
        id
        title
        slug
        cover_image
        position
        created_at
        view
        thumbnail
        description_body
        seo_description
        seo_title
      }
      amount
    }
  }
`;

export const GetArticleBySlug = gql`
  query GetArticleBySlug($articleSlug: String!) {
    getArticleBySlug(articleSlug: $articleSlug) {
      id
      title
      slug
      seo_title
      seo_image
      seo_description
      position
      created_at
      view
      thumbnail
      cover_image
      description_body
      drop_lead_delay_minutes
      is_pinned
    }
  }
`;
